import type { NavigateFunction } from 'react-router-dom'

/** Minimal user fields needed after login/register. */
export type PostLoginUser = {
  role: string
  onboarding_completed: boolean
}

/** Where a logged-in user should land (same rules as after login). */
export function getPostLoginPath(user: PostLoginUser): string {
  if (!user.onboarding_completed) {
    return '/onboarding'
  }
  if (user.role === 'tutor') {
    return '/tutor/dashboard'
  }
  if (user.role === 'god') {
    return '/admin/dashboard'
  }
  return '/dashboard'
}

export function navigateAfterLogin(user: PostLoginUser, navigate: NavigateFunction) {
  navigate(getPostLoginPath(user), { replace: true })
}
